/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, members: NonNullable<unknown> }} Partner_Detail_Row_PlanInputs */



/**
* | output |
* | --- |
* | "{plan} · {members} members" |
*
* @param {Partner_Detail_Row_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_row_plan = /** @type {((inputs: Partner_Detail_Row_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Row_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.plan} · ${i?.members} Mitglieder`)
	return /** @type {LocalizedString} */ (`${i?.plan} · ${i?.members} members`)
});